import {workOrderStatusListApprovalStates, WorkOrderStatus} from '@domain/shifthandover'
import {WorkOrderStatusLabel} from '@hconnect/common/components/eventProperties'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

export const WorkOrderStatusFilterDropDown: React.FC<CommonFilterDropDownProps<WorkOrderStatus>> = (
  props
) => {
  const {selectAll} = props
  return (
    <FilterDropDown
      {...props}
      options={workOrderStatusListApprovalStates}
      keyName="workOrderStatus"
      customTemplate={(status) => {
        return <WorkOrderStatusLabel status={status} />
      }}
      fullWidth={false}
      customDropDownFooter={(keyName) =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={keyName}
              selectAll={() => selectAll && selectAll(keyName, workOrderStatusListApprovalStates)}
            />
            <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
